/**
 * Component: producte-navegacio-colors
 * Per a incorporar amb "import" o "require", no s'ha de posar com a "src"
 * d'un script tag, i requereix crida a "init()".
 * Només pot haver un per document.
 * Ús:
 *     import ProducteNavegacioColors from './path/producte-navegacio-colors'
 *     NavegacioColors.init([options])
 * Veure init() i updateColorsNavigation() per a veure les opcions disponibles
 * i quins elemnts HTML s'espera trobar (alguns són opcionals).
 */

/* Imports */
import axios from 'axios';
import cartService from '../services/cart.service';

/**
 * Events
 */
const EVENT_COLOR_CHANGE = 'produce-navegacio-colors-color-change';
const EVENT_IMAGES_RELOADED = 'produce-navegacio-colors-images-reloaded';

/**
 * Elements jQuery.
 * Veure function init() per veure quins elements referencien.
 */
let $container;
let $colorsInfoProductes;
let $productImagesWrapper;
let $productRef;
let $productRefResp;
let $productPriceDiscountPercent; // optional
let $productPrice;
let $productPriceSticky;
let $productPriceRes;
let $productPricePrev;
let $productPricePrevSticky;
let $productPricePrevRes;
let $productXecRegalPriceValue;
let $productParticipacionsPriceValue;
let $productDispLabel;
let $productDispLabelM;
let $producteEnStockLabel;
let $producteEnStockLabelM;
let $productDispColor;
let $productDispColorM;
let $producteEnviamentGratuitBlock;
let $promoLabel;
let $buttonAddToBasket; // optional
let $buttonAddToBabylist; // optional

/* Altres valors del scope del component */
let colorsInfo;
let isCustomizer = false;
let ajaxColorDetailsUrl = '';
let ajaxImagesUrl = '';
let ningunoSeleccionadoLabel = '';
let updateViewTiemout = null;
const options = {
};

let currentColorButtons = {
    addToCart: true,
    addToBabylist: true
};

/**
 * @param array|undefined optionsIn {
 *          imagesLimit: int|undefined,
 *          imagesShowCustomizerButton: bool|undefined,
 *          imagesCols: int|undefined,
 *      }
 * @return void
 */
function init(optionsIn) {
    /* Carregal els elements jQuery */
    $container = $('.component-producte-navegacio-colors');
    $colorsInfoProductes = $container.find('.colors-info-producte');
    $productImagesWrapper = $('#product-images-wrapper');
    $productRef = $('#product-ref');
    $productRefResp = $('#product-ref-responsive');
    $productPriceDiscountPercent = $container.find('.product-price-disc-label');
    $productPrice = $('#product-price');
    $productPriceSticky = $('#product-price-sticky');
    $productPriceRes = $('#product-price-res');
    $productPricePrev = $('#product-price-prev');
    $productPricePrevSticky = $('#product-price-prev-sticky');
    $productPricePrevRes = $('#product-price-prev-res');
    $productXecRegalPriceValue = $('#product-xec-regal-a-obtenir');
    $productParticipacionsPriceValue = $('#product-participacions-a-obtenir');
    $productDispLabel = $('#envio-producto-label');
    $productDispLabelM = $('#product-disp-label-m');
    $producteEnStockLabel = $('#producte-en-stock-label');
    $producteEnStockLabelM = $('#producte-en-stock-label-m');
    $productDispColor = $('#product-disp-color');
    $productDispColorM = $('#product-disp-color-m');
    $producteEnviamentGratuitBlock = $('#product-enviament-gratuit-block');
    $buttonAddToBasket = $('#button-add-to-basket');
    $buttonAddToBabylist = $('#button-add-to-babylist');
    $promoLabel = $(".product_promo_oferta");

    if ($container.length == 0 || $colorsInfoProductes.length == 0) {
        return;
    }

    /* Llegir colorsInfo i pageType de data, veure
     * ProductViewModel::getColorsInfoFromProducte() */
    colorsInfo = $container.data('colors-info');
    isCustomizer = $container.data('is-customizer') == '1' ? true : false;
    ajaxColorDetailsUrl = $container.data('ajax-color-details-url');
    ajaxImagesUrl = $container.data('ajax-images-url');
    ningunoSeleccionadoLabel = $container.data('ninguno-seleccionado-label');

    /* Eventos de click en colores */
    $colorsInfoProductes.find('.colors__bt').on('click', function(event) {
        event.preventDefault();
        const $a = $(this);

        // No actualizamos aquí el estado, solo guardamos la información del click
        const isNoStock = $a.hasClass('colors__bt__no-stock');
        const isDescatalogado = $a.data('disponibilidad') === 'Descatalogado';

        console.log('Click en color:', {
            isNoStock,
            isDescatalogado,
            element: $a[0],
            classes: $a.attr('class'),
            data: $a.data()
        });

        // Solo llamamos a changeActiveColor y dejamos que la respuesta AJAX maneje los botones
        changeActiveColor($a.data('id_producte'), $a.data('id_producte_color'));
    });

    $(window).bind('popstate',
        function(event) {
            location.reload();
        });

    // Sincronizar estado inicial de los botones sticky
    syncStickyButtons();

    // Inicializar los manejadores de click
    handleButtonClicks();

    // Delegación del evento click para "Consultar plazo de entrega"
    $(document).on('click', '#consulta-plazo-entrega', function(e) {
        e.preventDefault();
        showPopup('consulta');
    });

    // Manejar el cierre del popup
    $(document).on('click', '.popup-central-close', function() {
        $('#popup-central').hide().removeClass('popup-central-active');
        $('.consulta-plazo-entrega-popup-inner, .consulta-plazo-entrega-popup-confirm, .aviso-disponibilidad-popup-inner, .aviso-disponibilidad-popup-confirm').hide();
        $('html').removeClass('side-open');
    });

    // También actualizar el evento de notificación de disponibilidad
    $(document).on('click', '#notify-availability-button', function() {
        showPopup('aviso');
    });

    return this;
}

/* Actualitza la vista i llença esdeveniment de canvi */
function updateView () {
    clearTimeout(updateViewTiemout);
    updateViewTiemout = setTimeout(() => {
        updateColorsNavigation();
        reloadProductDetails();
        reloadImages();
        dispatchEvent(EVENT_COLOR_CHANGE);
    }, 50)
}

/**
 * Regenera el parametre de la url amb els colors seleccionats
 */
function changeColorParameters() {
    var paramsString = [];

    // producte amb nomes 1 color
    if($('#product-ref').html() !== "" && $('#product-ref').html() !== undefined) {
        paramsString.push($('#product-ref').html());
    } else {
        const elements = document.querySelectorAll('.producte-color-referencia');
        Array.from(elements).forEach((elem) => {
            /*if(window.innerWidth > 767) {  }*/
            if(elem.innerText && elem.innerText.trim() !== undefined && elem.innerText.trim() !== '&nbsp;' && elem.innerText.trim() !== '') {
                paramsString.push(elem.innerText);
            }
        });
    }
    var search_params = new URLSearchParams(window.location.search);
    search_params.delete('color_ref');
    let unique_search_params = [...new Set(paramsString)];
    search_params.set('color_ref', unique_search_params.join(','));
    window.history.pushState('bitti name', 'bitti title', window.location.origin + window.location.pathname + '?' + search_params.toString().replaceAll('%2C', ',') );
}

/**
 * Retorna info dels colors seleccionats
 * @return array<object>
 */
function getActiveColors () {
    const activeColors = [];
    colorsInfo.productes_integrants.forEach((producte) => {
        let activeColor = null;
        producte.colors.forEach((color) => {
            if (color.active) {
                activeColor = color;
            }
        });
        if (activeColor && activeColor.id_producte_color) {
            activeColors.push(activeColor);
        }
    });
    return activeColors;
}

/**
 * Add event listener amb ajuda de document. Suposa que només hi ha una
 * instància d'aquest component.
 * @param string type
 * @param function callback
 * @return void
 */
function addEventListener (type, callback) {
    document.addEventListener(type, callback);
}

/**
 * Dispatch event amb l'ajuda de document.
 * @param string type
 */
function dispatchEvent (type) {
    document.dispatchEvent(new Event(type));
}

/**
 * Retorna el color seleccionat d'un producte en concret.
 * @param string idProducte
 * @return object|null
 */
function getActiveColorForProducte (idProducte) {
    const activeColors = getActiveColors();
    let activeColor = null;
    activeColors.forEach((color) => {
        if (idProducte == color.id_producte) {
            activeColor = color;
        }
    });
    return activeColor;
}

/**
 * @return string
 */
function getIdProducte () {
    return colorsInfo.id_producte;
}

/**
 * @return array<string>
 */
function getActiveColorIds ()
{
    return getActiveColors().map(color => color.id_producte_color);
}

/**
 * Canvia els colors actius
 * @param array idsProducteColor
 * @return void
 */
function setActiveColorIds (idsProducteColor)
{
    colorsInfo.productes_integrants.forEach((producte) => {
        /* Check if color exist */
        let exists = false;
        producte.colors.forEach((color) => {
            exists ||= idsProducteColor
                .includes(color.id_producte_color);
        });
        /* if exitst, set */
        if (exists) {
            producte.colors.forEach((color) => {
                color.active = idsProducteColor
                    .includes(color.id_producte_color);
            });
        } else {
            producte.colors.forEach((color) => {
                color.active = !color.id_producte_color;
            });
        }
    });
    updateView();
}

/**
 * Canvia el color actiu del procucte especificat a la var colorsInfo.
 * @param string idProducte
 * @param string idProductecolor
 * @return void
 */
function changeActiveColor (idProducte, idProducteColor)
{
    console.log('Cambiando color activo:', { idProducte, idProducteColor });

    colorsInfo.productes_integrants.forEach((producte) => {
        if (producte.id_producte == idProducte) {
            producte.colors.forEach((color) => {
                color.active = color.id_producte_color == idProducteColor;
            });
        }
    });

    // Asegurar que la vista se actualiza y los botones se sincronizan
    updateView();

    // Añadir una sincronización adicional después de un pequeño delay
    setTimeout(() => {
        console.log('Sincronización adicional después de cambio de color');
        syncStickyButtons();
    }, 200);
}

/**
 * Refresca el HTML
 * @return void
 */
function updateColorsNavigation () {
    /* Here we keep array (0 based) of activated */
    const activatedArr = [];

    /* Update labels and color highlights */
    $colorsInfoProductes.each (function (event) {
        const idProducte = $(this).data('id_producte');
        const activeColor = getActiveColorForProducte(idProducte);
        activatedArr.push(Boolean(activeColor));
        if (activeColor) {
            $(this).find('.producte-color-referencia').html(activeColor.referencia);
            $(this).find('.producte-color-etiqueta').html(activeColor.etiqueta);

            $('#pills-tabContent #pills-'+idProducte+' .producte-color-referencia')
                .html(activeColor.referencia);
            $('#pills-tabContent #pills-'+idProducte+' .producte-color-etiqueta')
                .html(activeColor.etiqueta);

            $('.sticky-product-bar__details #name-producte-' + idProducte + '.producte-color-etiqueta')
                .html(activeColor.etiqueta);

            $(`.sticky-product-bar__details .colors__product[data-sticky-colors] .colors__bt[data-id_producte="${idProducte}"]`)
                .find('.product-color-picker-bg')
                .css('background-color', activeColor.color_hex);

        } else {
            $(this).find('.producte-color-referencia').html('');
            $(this).find('.producte-color-etiqueta').html(ningunoSeleccionadoLabel);

            $('#pills-tabContent #pills-'+idProducte+' .producte-color-referencia')
                .html('');
            $('#pills-tabContent #pills-'+idProducte+' .producte-color-etiqueta')
                .html(ningunoSeleccionadoLabel);
        }
        $(this).find('a').each(function (event) {
            const $a = $(this);
            const idProducteColor = $a.data('id_producte_color');
            if ((activeColor && idProducteColor == activeColor.id_producte_color) ||
                (!activeColor && !idProducteColor))
            {
                $a.addClass($a.data('active-class'));
            } else {
                $a.removeClass($a.data('active-class'));
            }
        });
        //resp
        $('#pills-tabContent #pills-'+idProducte+' .owl-item').find('a.colors__bt').each(function (event) {
            const $a = $('#pills-tabContent #pills-'+idProducte+' .owl-item').find('a.colors__bt');
            $a.removeClass($a.data('active-class'));
        });
        if(activeColor) {
            $('#pills-tabContent #pills-'+idProducte+' .owl-item').find('a.colors__bt[data-id_producte_color='+activeColor.id_producte_color+']').each(function (event) {
                const $a = $('#pills-tabContent #pills-'+idProducte+' .owl-item').find('a.colors__bt[data-id_producte_color='+activeColor.id_producte_color+']');
                $a.addClass($a.data('active-class'));
            });
        } else {
            $('#pills-tabContent #pills-'+idProducte+' .owl-item').find('a.colors__bt.colors__bt--no-selection').each(function (event) {
                const $a = $('#pills-tabContent #pills-'+idProducte+' .owl-item').find('a.colors__bt.colors__bt--no-selection');
                $a.addClass($a.data('active-class'));
            });
        }
    });

    /* DESKTOP: Now deactivate those that don't meet requirements */
    $colorsInfoProductes.each(function () {
        deactivateProductsNotMeetingRequirements($(this));
    });

    /* RESPONSIVE: Now deactivate those that don't meet requirements */
    /*$colorsInfoProductesResponsive.each(function () {
        deactivateProductsNotMeetingRequirements($(this));
    });*/

    function deactivateProductsNotMeetingRequirements(prod) {
        const idProducte = prod.data('id_producte');
        const requiredIndexes = prod.data('required_indexes');
        const disabledClass = prod.data('disabled-class');
        let activate = true;
        if (!Array.isArray(requiredIndexes)) {
            return;
        }
        requiredIndexes.forEach((activatedIndex) => {
            if (!activatedArr[activatedIndex]) {
                activate = false;
            }
        });
        if (activate) {
            prod.removeClass(disabledClass);
        } else if (!prod.hasClass(disabledClass)) {
            const activeColor = getActiveColorForProducte(idProducte);
            prod.addClass(disabledClass);
            if (activeColor) {
                /* If it has color selected, deselect, one at a time */
                changeActiveColor(idProducte, '');
            }
        }
    }
}

/**
 * @return void
 */
function reloadProductDetails() {
    console.log('Iniciando reloadProductDetails');

    const query = {
        id_producte: colorsInfo.id_producte,
        ids_producte_color: getActiveColors().map((color) => {
            return color.id_producte_color;
        }),
    };

    console.log('Query para AJAX:', query);

    axios.get(ajaxColorDetailsUrl, {
        params: query,
    }).then((response) => {
        console.log('Respuesta del servidor:', response.data);

        // Actualizar etiquetas de disponibilidad
        if (response.data.dispLabel) {
            $productDispLabel.html(response.data.dispLabel);
            $productDispLabelM.html(response.data.dispLabel);
        }

        const isVisible = response.data.visible;
        const isDescatalogado = response.data.dispLabel === 'Descatalogado';
        const isAgotado = response.data.dispLabel === 'Agotado temporalmente';
        const isWishlist = $container.data('is-wishlist') === 1;
        console.log('Estado:', { isDescatalogado, isAgotado, isWishlist });

        // Limpiar contenedores de botones existentes
        $('#button-add-to-basket, #consulta-disponibilidad').remove();
        $('#button-add-to-basket-sticky, #consulta-disponibilidad-sticky').remove();

        // Obtener los contenedores
        const $buttonContainer = $('.colors-info-producte-wrapper').first();
        const $buttonContainerSticky = $('.sticky-product-bar__actions').first();

        if (isWishlist) {
            // Lógica para babylist: solo botón de añadir a la lista
            const $addToBabylistBtn = $('#button-add-to-babylist');
            const $addToBabylistBtnSticky = $('#button-add-to-babylist-sticky');

            if (isDescatalogado) {
                $addToBabylistBtn.addClass('button-add-disabled');
                $addToBabylistBtnSticky.addClass('button-add-disabled');
            } else {
                $addToBabylistBtn.removeClass('button-add-disabled');
                $addToBabylistBtnSticky.removeClass('button-add-disabled');
            }
        } else {
            // Lógica normal para la tienda
            if (isDescatalogado|| !isVisible) {
                // Botón de añadir al carrito deshabilitado
                const $addToCartBtn = $('<a id="button-add-to-basket" href="javascript:" class="btn btn-secondary rounded-0 form__inputsubmit button-add-disabled">').text(document.querySelector('[data-addtocart-text]')?.dataset.addtocartText || 'Añadir al carrito');
                const $addToCartBtnSticky = $addToCartBtn.clone().attr('id', 'button-add-to-basket-sticky');

                $buttonContainer.append($addToCartBtn);
                $buttonContainerSticky.append($addToCartBtnSticky);
            } else if (isAgotado || !response.data.canBeAddedToCart) {
                // Botón de consultar disponibilidad
                const $consultaBtn = $('<a href="javascript:" id="consulta-disponibilidad" class="btn btn-secondary rounded-0">' +
                    '<img src="/images/product/icon-mail.svg">' +
                    'Avisarme cuando esté disponible' +
                '</a>');
                const $consultaBtnSticky = $consultaBtn.clone().attr('id', 'consulta-disponibilidad-sticky');

                $buttonContainer.append($consultaBtn);
                $buttonContainerSticky.append($consultaBtnSticky);

                // Añadir eventos para abrir el popup
                $consultaBtn.on('click', function() {
                    $('#popup-central').css('display', 'flex');
                    $('.aviso-disponibilidad-popup-inner').show();
                    $('html').addClass('side-open');
                });

                $consultaBtnSticky.on('click', function() {
                    $('#popup-central').css('display', 'flex');
                    $('.aviso-disponibilidad-popup-inner').show();
                    $('html').addClass('side-open');
                });
            } else {
                // Botón normal de añadir al carrito
                const $addToCartBtn = $('<a id="button-add-to-basket" href="javascript:" class="btn btn-secondary rounded-0 form__inputsubmit">').text(document.querySelector('[data-addtocart-text]')?.dataset.addtocartText || 'Añadir al carrito');
                const $addToCartBtnSticky = $addToCartBtn.clone().attr('id', 'button-add-to-basket-sticky');

                $buttonContainer.append($addToCartBtn);
                $buttonContainerSticky.append($addToCartBtnSticky);
            }
        }

        // Actualizar el resto de la información del producto
        updateProductInfo(response.data);

        // Reactivar eventos de los botones
        reattachButtonEvents();
    }).catch(error => {
        console.error('Error en reloadProductDetails:', error);
    });
}

// Función para añadir al carrito
function addToCart($button) {
    if ($button.hasClass('button-add-disabled')) return;

    $button.css('opacity', 0.5).css('pointer-events', 'none');

    const idProducte = colorsInfo.id_producte;
    const activeColorIds = getActiveColorIds();
    let personalizacion = '';

    if ($button.data('is-personalitzable')) {
        const textPersonalitzacio = getPromptPersonalitzacioText(
            $button.data('personalitzable-message'),
            $button.data('personalitzable-length-error-message')
        );
        if (textPersonalitzacio !== null) {
            personalizacion = textPersonalitzacio;
        } else {
            $button.css('opacity', 1).css('pointer-events', 'auto');
            return;
        }
    }

    if (idProducte && activeColorIds.length > 0) {
        cartService.addArticle(idProducte, activeColorIds, 1, personalizacion)
            .finally(() => {
                $button.css('opacity', 1).css('pointer-events', 'auto');
            });
    }
}

// Definir la función getPromptPersonalitzacioText
function getPromptPersonalitzacioText(message, lengthErrorMessage) {
    let text = '';
    while (text === '' || text.length > 14) {
        text = prompt(message, text);
        if (text === null) {
            break;
        } else if (text.length > 14) {
            alert(lengthErrorMessage);
        }
    }
    return text;
}

// En la función reattachButtonEvents
function reattachButtonEvents() {
    // Reactivar evento para el botón principal
    $('#button-add-to-basket').off('click').on('click', function(event) {
        event.preventDefault();
        const jqBt = $(this);

        if (!jqBt.hasClass('button-add-disabled')) {
            jqBt.css('opacity', 0.5);
            jqBt.css('pointer-events', 'none');

            const idProducte = colorsInfo.id_producte; // Usar directamente colorsInfo
            const activeColorIds = getActiveColorIds();
            let personalizacion = '';

            if (jqBt.data('is-personalitzable')) {
                const textPersonalitzacio = getPromptPersonalitzacioText(
                    jqBt.data('personalitzable-message'),
                    jqBt.data('personalitzable-length-error-message')
                );
                if (textPersonalitzacio !== null) {
                    personalizacion = textPersonalitzacio;
                } else {
                    jqBt.css('opacity', 1);
                    jqBt.css('pointer-events', 'auto');
                    return;
                }
            }

            if (idProducte && activeColorIds.length > 0) {
                cartService.addArticle(idProducte, activeColorIds, 1, personalizacion)
                    .finally(() => {
                        jqBt.css('opacity', 1);
                        jqBt.css('pointer-events', 'auto');
                    });
            }
        }
    });

    // Reactivar evento para el botón sticky
    $('#button-add-to-basket-sticky').off('click').on('click', function() {
        $('#button-add-to-basket').click();
    });
}

function updateButtonsVisibility() {
    console.log('Iniciando updateButtonsVisibility');

    // Definir las plantillas de los botones
    const addToCartButtonTemplate = `
        <a id="button-add-to-basket" href="javascript:"
           class="btn btn-secondary rounded-0 form__inputsubmit tag-manger-event-click">
            ${document.querySelector('[data-addtocart-text]')?.dataset.addtocartText || 'Añadir al carrito'}
        </a>
    `;

    const addToCartButtonStickyTemplate = `
        <a id="button-add-to-basket-sticky" href="javascript:"
           class="btn btn-secondary rounded-0 form__inputsubmit tag-manger-event-click">
            ${document.querySelector('[data-addtocart-text]')?.dataset.addtocartText || 'Añadir al carrito'}
        </a>
    `;

    const consultaButtonTemplate = `
        <a href="javascript:" id="consulta-disponibilidad" class="btn btn-secondary rounded-0">
            <img src="/images/product/icon-mail.svg">
            Avisarme cuando esté disponible
        </a>
    `;

    const consultaButtonStickyTemplate = `
        <a href="javascript:" id="consulta-disponibilidad-sticky" class="btn btn-secondary rounded-0">
            <img src="/images/product/icon-mail.svg">
            Avisarme cuando esté disponible
        </a>
    `;

    // Buscar los contenedores
    const $buttonContainer = $('.colors-info-producte-wrapper').first();
    const $buttonContainerSticky = $('.sticky-product-bar__actions').first();

    // Verificar el estado actual
    const displayLabel = document.querySelector('#product-disp-label')?.textContent || '';
    const isDescatalogado = displayLabel.includes("Descatalogado");
    const isProximamente = displayLabel.includes("Próximamente");
    const isAgotado = displayLabel.includes("Agotado temporalmente") || displayLabel.includes("Agotado");
    const canAddToCart = currentColorButtons.addToCart && !isProximamente && !isAgotado;

    console.log('Estado actual:', {
        displayLabel,
        isDescatalogado,
        isProximamente,
        isAgotado,
        canAddToCart
    });

    // Primero eliminar todos los botones existentes
    $('#button-add-to-basket, #button-add-to-basket-sticky, #consulta-disponibilidad, #consulta-disponibilidad-sticky').remove();

    if ($buttonContainer.length) {
        if (isDescatalogado) {
            // Para productos descatalogados, mostrar botón de añadir al carrito deshabilitado
            const $addToCartBtn = $(addToCartButtonTemplate).addClass('button-add-disabled');
            $buttonContainer.append($addToCartBtn);
        } else if (isAgotado || !canAddToCart) {
            // Para productos agotados o que no se pueden añadir al carrito, mostrar botón de consulta
            const $consultaBtn = $(consultaButtonTemplate);
            $buttonContainer.append($consultaBtn);
        } else {
            // Para productos disponibles, mostrar botón de añadir al carrito normal
            const $addToCartBtn = $(addToCartButtonTemplate);
            $buttonContainer.append($addToCartBtn);
        }
    }

    if ($buttonContainerSticky.length) {
        if (isDescatalogado) {
            const $addToCartBtnSticky = $(addToCartButtonStickyTemplate).addClass('button-add-disabled');
            $buttonContainerSticky.append($addToCartBtnSticky);
        } else if (isAgotado || !canAddToCart) {
            const $consultaBtnSticky = $(consultaButtonStickyTemplate);
            $buttonContainerSticky.append($consultaBtnSticky);
        } else {
            const $addToCartBtnSticky = $(addToCartButtonStickyTemplate);
            $buttonContainerSticky.append($addToCartBtnSticky);
        }
    }

    // Reactivar eventos de los botones
    reattachButtonEvents();

    // Sincronizar estado de los botones
    syncStickyButtons();

    console.log('Estado final de los botones:', {
        addToCartExists: $('#button-add-to-basket').length > 0,
        addToCartSticky: $('#button-add-to-basket-sticky').length > 0,
        consultaExists: $('#consulta-disponibilidad').length > 0,
        consultaSticky: $('#consulta-disponibilidad-sticky').length > 0,
        isAgotado,
        canAddToCart
    });
}

/**
 * @return void
 */
function reloadImages() {
    const query = {
        id_producte: colorsInfo.id_producte,
        ids_producte_color: getActiveColors().map((color) => {
            return color.id_producte_color;
        }),
    };

    axios.get(ajaxImagesUrl, {
        params: query,
    }).then((response) => {
        $productImagesWrapper.html(response.data);
        dispatchEvent(EVENT_IMAGES_RELOADED);
    }).then(() => {
        // Añadir verificación de existencia del elemento
        const firstSlide = document.querySelector(".product-slider .slide-item");
        const popupImage = document.querySelector("#first_image_popup");

        if (firstSlide && popupImage && firstSlide.style.backgroundImage) {
            popupImage.src = firstSlide.style.backgroundImage.slice(5, -2);
        }
    }).catch(error => {
        console.warn('Error al cargar las imágenes:', error);
    });
}

// Buscar donde se maneja la selección de colores y modificar
function handleColorSelection(event) {
    const $colorButton = $(event.currentTarget);
    const $colorGroup = $colorButton.closest('.colors__product');

    // Actualizar selección
    $colorGroup.find('.colors__bt').removeClass('colors__bt__select');
    $colorButton.addClass('colors__bt__select');

    // NO ocultar el botón de más colores
    // Eliminar o comentar cualquier línea que haga:
    // $('#open-color-selector-popup').hide();
    // o
    // $('.color-plus').hide();

    // Resto del código de manejo de selección...
}

// Primero definimos updateProductInfo
function updateProductInfo(data) {
    console.log('Actualizando información del producto:', {
        preu: data.preu,
        preuPrev: data.preuPrev,
        hasDiscount: !!data.preuPrev && data.preuPrev !== data.preu,
        promocioValorOferta: data.productePromocioValorOferta
    });

    // Actualizar referencia
    if (data.producteComposedRef) {
        $productRef.html(data.producteComposedRef);
        $productRefResp.html(data.producteComposedRef);
    }

    // Actualizar precios
    if (data.preu !== undefined) {
        const formattedPrice = formatHtmlPrice(data.preu);
        $productPrice.html(formattedPrice);
        $productPriceRes.html(formattedPrice);
        $productPriceSticky.html(formattedPrice).css({
            'white-space': 'nowrap',
            'display': 'inline-flex',
            'align-items': 'baseline'
        });
    }

    // Actualizar precio anterior y etiqueta de descuento
    const hasDiscount = !!data.preuPrev && data.preuPrev !== data.preu;

    if (hasDiscount) {
        const formattedPrevPrice = formatHtmlPrice(data.preuPrev);
        $productPricePrev.html(formattedPrevPrice).show();
        $productPricePrevRes.html(formattedPrevPrice).show();
        $productPricePrevSticky.html(formattedPrevPrice).show().css({
            'white-space': 'nowrap',
            'display': 'inline-flex',
            'align-items': 'baseline'
        });

        if (data.productePromocioValorOferta) {
            $('.product-price-disc-label').removeClass('discount-disabled').show();
            $('.product-price-disc-label').html("-" + data.productePromocioValorOferta);
        }
    } else {
        $productPricePrev.html('').hide();
        $productPricePrevRes.html('').hide();
        $productPricePrevSticky.html('').hide();
        $('.product-price-disc-label').addClass('discount-disabled').hide();
    }

    // Actualizar etiquetas de disponibilidad
    if (data.dispLabel) {
        $productDispLabel.html(data.dispLabel);
        $productDispLabelM.html(data.dispLabel);

        // Actualizar etiquetas de stock
        if (data.canBeAddedToCart && !data.dispLabel.includes('Consultar disponibilidad') && data.enStock) {
            $producteEnStockLabel.css('display', 'inline-block');
            $producteEnStockLabelM.css('display', 'inline-block');
        } else {
            $producteEnStockLabel.css('display', 'none');
            $producteEnStockLabelM.css('display', 'none');
        }
    }

    // Actualizar color de disponibilidad
    if (data.dispColor) {
        $productDispColor.attr('class', data.dispColor);
        $productDispColorM.attr('class', data.dispColor);
    }

    // Actualizar bloque de envío gratuito
    if (data.preu && parseFloat(data.preu.replace(',', '.')) >= 50) {
        $producteEnviamentGratuitBlock.css('display', 'block');
    } else {
        $producteEnviamentGratuitBlock.css('display', 'none');
    }

    // Actualizar etiqueta de promoción
    if (data.promoLabel) {
        $promoLabel.html(data.promoLabel).css('display', 'block');
    } else {
        $promoLabel.css('display', 'none');
    }

    // Actualizar contenedor de labels
    updateLabels(data);

    console.log('Estado final de precios:', {
        precioNormal: $productPrice.html(),
        precioSticky: $productPriceSticky.html(),
        precioAnterior: $productPricePrev.html(),
        precioAnteriorSticky: $productPricePrevSticky.html(),
        tieneDescuento: hasDiscount,
        descuentoVisible: !$productPriceDiscountPercent.hasClass('discount-disabled'),
        etiquetaDescuentoVisible: $('.product-price-disc-label').is(':visible')
    });
}

function formatHtmlPrice(price) {
    const match = price.match(/^([\d.]+),(\d+)\s*([^\d\s]+)?$/);
    if (match) {
        const [, euros, centimos, simbolo] = match;
        return `${euros}<sup>,${centimos}</sup>&nbsp;${simbolo || ''}`.trim();
    }
    return price;
}

function updateLabels(data) {
    const $contenedorLabels = $('#contenedor-labels');
    $contenedorLabels.empty();

    if (data.dispLabel === "Próximamente") {
        $contenedorLabels.append('<span class="stock-label stock-label-proximamente">' + data.dispLabel + '</span>');
    } else if (data.dispLabel === "Descatalogado") {
        $contenedorLabels.append('<span class="stock-label stock-label-oos">' + data.dispLabel + '</span>');
    } else if (data.canBeAddedToCart && !data.dispLabel.includes('Consultar disponibilidad') && data.enStock) {
        $contenedorLabels.append('<span class="stock-label stock-label-available">En stock</span>');
    } else if (data.dispLabel === 'Agotado temporalmente') {
        $contenedorLabels.append('<span class="stock-label stock-label-oos">Agotado temporalmente</span>');
    } else if(!data.dispLabel.includes('semanas laborables') && !data.dispLabel.includes('días laborables')){
        $contenedorLabels.append('<a href="javascript:void(0);" id="consulta-plazo-entrega" class="stock-consulta stock-label">Consultar plazo de entrega</a>');
    }
}

// Nueva función para sincronizar botones
function syncStickyButtons() {
    console.log('Iniciando syncStickyButtons');

    const $mainButton = $('#button-add-to-basket');
    const $stickyButton = $('#button-add-to-basket-sticky');

    console.log('Botones encontrados:', {
        mainButton: $mainButton.length > 0,
        stickyButton: $stickyButton.length > 0,
        mainButtonDisabled: $mainButton.hasClass('button-add-disabled'),
        stickyButtonDisabled: $stickyButton.hasClass('button-add-disabled')
    });

    if ($mainButton.length && $stickyButton.length) {
        // Sincronizar estado disabled
        const isMainDisabled = $mainButton.hasClass('button-add-disabled');
        console.log('Estado del botón principal:', {
            isDisabled: isMainDisabled,
            classes: $mainButton.attr('class'),
            personalizable: $mainButton.attr('data-is-personalitzable')
        });

        if (isMainDisabled) {
            $stickyButton.addClass('button-add-disabled')
                        .attr('disabled', 'disabled')
                        .css('pointer-events', 'none');
            console.log('Deshabilitando botón sticky');
        } else {
            $stickyButton.removeClass('button-add-disabled')
                        .removeAttr('disabled')
                        .css('pointer-events', '');
            console.log('Habilitando botón sticky');
        }

        // Sincronizar otros atributos relevantes
        $stickyButton.attr('data-is-personalitzable', $mainButton.attr('data-is-personalitzable'));

        console.log('Estado final de los botones:', {
            mainButtonDisabled: $mainButton.hasClass('button-add-disabled'),
            stickyButtonDisabled: $stickyButton.hasClass('button-add-disabled'),
            mainButtonClasses: $mainButton.attr('class'),
            stickyButtonClasses: $stickyButton.attr('class')
        });
    }
}

// Añadir un listener para el evento de cambio de color
addEventListener(EVENT_COLOR_CHANGE, function() {
    console.log('Evento COLOR_CHANGE detectado - Iniciando sincronización');
    syncStickyButtons();
});

// Nueva función para manejar los eventos click de los botones
function handleButtonClicks() {
    // Manejar clicks en botones de wishlist (normal y sticky)
    $('#button-add-to-babylist, #button-add-to-babylist-sticky').on('click', function(e) {
        if ($(this).hasClass('button-add-disabled')) {
            e.preventDefault();
            e.stopPropagation();
            return false;
        }
    });

    // Manejar clicks en botones de carrito (normal y sticky)
    $('#button-add-to-basket, #button-add-to-basket-sticky').on('click', function(e) {
        if ($(this).hasClass('button-add-disabled')) {
            e.preventDefault();
            e.stopPropagation();
            return false;
        }
    });
}

function showPopup(type) {
    $('#popup-central').show().addClass('popup-central-active'); // Añadir clase para centrado

    // Ocultar todos los popups primero
    $('.consulta-plazo-entrega-popup-inner, .consulta-plazo-entrega-popup-confirm, .aviso-disponibilidad-popup-inner, .aviso-disponibilidad-popup-confirm').hide();

    // Mostrar el popup específico
    if (type === 'consulta') {
        $('.consulta-plazo-entrega-popup-inner').show().css({
            'display': 'flex',
            'flex-direction': 'column',
            'position': 'fixed',
            'top': '50%',
            'left': '50%',
            'transform': 'translate(-50%, -50%)',
            'z-index': '1000'
        });
    } else if (type === 'aviso') {
        $('.aviso-disponibilidad-popup-inner').show().css({
            'display': 'flex',
            'flex-direction': 'column',
            'position': 'fixed',
            'top': '50%',
            'left': '50%',
            'transform': 'translate(-50%, -50%)',
            'z-index': '1000'
        });
    }

    $('html').addClass('side-open');
}

/* Exportem les funcions i constants accessibles des de fora */
export default {
    init,
    updateView,
    updateColorsNavigation,
    setActiveColorIds,
    changeActiveColor,
    getIdProducte,
    getActiveColorIds,
    addEventListener,
    EVENT_COLOR_CHANGE,
    EVENT_IMAGES_RELOADED,
};
